import { frontAxios } from "./frontAxios";


export function getEvents() {
    
    return frontAxios.get("/events")
  }
  